// Lote V-8 — Web client para o feed de notificacións.

import { apiClient } from './client';

export interface NotificationItem {
  id: string;
  type: string;
  title: string;
  text: string;
  data_json: unknown;
  read_at: string | null;
  created_at: string;
}

export interface NotificationListResponse {
  notifications: NotificationItem[];
  unread_count: number;
}

export interface UnreadCountResponse {
  unread_count: number;
}

export async function listNotifications(limit = 30): Promise<NotificationListResponse> {
  const { data } = await apiClient.get<NotificationListResponse>(
    `/api/v1/notifications?limit=${limit}`,
  );
  return data;
}

export async function getUnreadCount(): Promise<number> {
  const { data } = await apiClient.get<UnreadCountResponse>('/api/v1/notifications/unread-count');
  return data.unread_count;
}

export async function markNotificationRead(id: string): Promise<void> {
  await apiClient.patch(`/api/v1/notifications/${encodeURIComponent(id)}/read`);
}

export async function markAllNotificationsRead(): Promise<number> {
  const { data } = await apiClient.patch<{ marked_read: number }>(
    '/api/v1/notifications/mark-all-read',
  );
  return data.marked_read;
}
